// import { ClassNames } from '@emotion/react';
// import axios from 'axios';
// import { format, startOfDay, addHours } from 'date-fns';

// const handleAssignmentTypeChange = (event, assignments, setAssignmentType, setSelectedAssignmentId, selectedExamId, setError) => {
//     setAssignmentType(event.target.value);

//     let assignmentId = assignments.find(a => a.name === event.target.value)?.id || null;
//     // Special case: "Groups" → force assignmentId = 4
//     if (event.target.value === "Groups") {
//         assignmentId = 4;
//     }
//     setSelectedAssignmentId(assignmentId);
//     if (!selectedExamId) {

//         setError("Please select an assessment before choosing an assignment type.");
//     }
// };




// const mergeAssignedData = (data, assignmentId, setAssignedData) => {
//     setAssignedData((prev) => {
//         const filteredPrev = prev.filter(item => item.assignmentId !== assignmentId);
//         const taggedNew = data.map(item => ({ ...item, assignmentId }));
//         return [...filteredPrev, ...taggedNew];
//     });
// };

// const handleAssign = (difficultyId, scheduleDate, expiryDate, selectedExamId, assignedData, oneTimeEmployees, selectedExamDuration, setError, setConfirmationType, setConfirmOpen, isEdit, assignmentType,               // new
//     selectedEmployeesCount,      // new
//     selectedDepartmentsCount) => {
//     setError("");
//     try {
//         if (!isEdit) {
//             // Basic required fields
//             if (!scheduleDate) { setError("Schedule date is required"); return; }
//             if (!expiryDate) { setError("Expiry date is required"); return; }
//             if (!selectedExamId) { setError("Assessment is required"); return; }

//             // Assignment type validation
//             if (!assignmentType) {
//                 setError("Please select an assignment type (Individual or Department).");
//                 return;
//             }

//             // Individual type: check if at least one employee is selected
//             if (assignmentType === "Individual") {
//                 const hasEmployees = selectedEmployeesCount > 0 || (oneTimeEmployees && oneTimeEmployees.length > 0);
//                 if (!hasEmployees) {
//                     setError("At least one employee must be assigned.");
//                     return;
//                 }
//             }
//             // Department type: check if at least one department is selected
//             else if (assignmentType === "Department") {
//                 if (!selectedDepartmentsCount) {
//                     setError("At least one department must be assigned.");
//                     return;
//                 }
//             }
//             // Optional: handle Groups (assignmentId 4) – if needed
//             else if (assignmentType === "Groups") {
//                 // Add your logic here if Groups require any validation
//                 // For now, we allow it but you can add a check
//             }
//             // Fallback for any other type
//             else {
//                 setError("Invalid assignment type selected.");
//                 return;
//             }
//         }
//         const scheduleDateTime = new Date(scheduleDate);
//         const expiryDateTime = new Date(expiryDate);
//         if (expiryDateTime <= scheduleDateTime) {
//             setError("Expiry date and time must be after schedule date and time.");
//             return;
//         }
//         // const validExamId = Number.isFinite(Number(selectedExamId)) ? selectedExamId : 1;
//         // const basePayload = {
//         //     difficultyId,
//         //     scheduleDate,
//         //     expiryDate,
//         //     examId: validExamId,
//         //     duration: selectedExamDuration,
//         // };
//         setConfirmationType("save");
//         setConfirmOpen(true);
//     } catch (err) {
//         setError("Unexpected error occurred while assigning assessment.");
//     }
// };

// const resetform = (
//     setAssignmentType,
//     setSelectedDepartments,
//     setSelectedEmployees,
//     setDifficulty,
//     setExams,
//     setScheduleDate,
//     setExpiryDate,
//     setOneTimeUsers,
//     setDifficultyId,
//     setSelectedExam,
//     setSelectedExamId,
//     setAssignedData,
//     setSelectedAssignmentId,
//     setIndividuals,
//     setDepartments,
//     navigate
// ) => {
//     if (setAssignmentType) setAssignmentType(null);
//     setSelectedDepartments([]);
//     setSelectedEmployees([]);
//     setDifficulty('');
//     setExams([]);
//     setScheduleDate(format(addHours(startOfDay(new Date()), 9), "yyyy-MM-dd'T'HH:mm"));
//     setExpiryDate(format(addHours(startOfDay(new Date()), 18), "yyyy-MM-dd'T'HH:mm"));
//     setOneTimeUsers([]);
//     setDifficultyId(null);
//     setSelectedExam('');
//     setSelectedExamId(null);
//     setAssignedData([]);
//     setSelectedAssignmentId(null);
//     setIndividuals([]);
//     setDepartments([]);
//     navigate('/hr/assignment-exams');
// };

// const confirmSaveCourse = async (isEdit, assignedData, oneTimeEmployees, difficultyId, scheduleDate, expiryDate, selectedExamId, selectedExamDuration, setError, setConfirmOpen, setSuccessOpen, selectedAssignmentId, workStart, workEnd, autoScheduling, navigate) => {
//     setError("");
//     console.log("Confirm Save Course triggered");
//     setConfirmOpen(false);
//     const finalAssignedData = (Array.isArray(assignedData) ? assignedData : []).filter((item) => {
//         if (isEdit === false) return item.isActive === true;
//         if (isEdit === true) return true;
//         return item.isActive === true;
//     });

//     const finalOneTimeAssignedData = (Array.isArray(oneTimeEmployees) ? oneTimeEmployees : []).filter((item) => {
//         if (isEdit === false) return item.isActive === true;
//         if (isEdit === true) return true;
//         return item.isActive === true;
//     });
//     // const normalize = (emp) => ({
//     //     id: emp.id ?? null,
//     //     employeeId: emp.employeeId ?? null,
//     //     employeeName: emp.employeeName?.trim() || "",
//     //     departmentId: emp.departmentId ?? null,
//     //     departmentName: emp.departmentName ?? "",
//     //     assignmentId: emp.assignmentId ?? 1,
//     //     isActive: emp.isActive ?? true,
//     //     status: emp.status ?? "Scheduled",
//     //     examId: selectedExamId,
//     // });
    
    
    
//     const normalize = (emp) => ({
//     employee_guid:
//         emp.employee_guid ??
//         emp.id ??
//         emp.employeeId ??
//         null,

//     employeeId:
//         emp.employeeId ??
//         emp.id ??
//         null,

//     employeeName:
//         emp.employeeName?.trim() || "",

//     departmentId:
//         emp.departmentId ?? null,

//     departmentName:
//         emp.departmentName ?? "",

//     groupId:
//         emp.groupId ?? null,

//     groupName:
//         emp.groupName ?? "",

//     assignmentId:
//         emp.assignmentId ?? selectedAssignmentId,

//     isActive:
//         emp.isActive ?? true,

//     status:
//         emp.status ?? "Scheduled",

//     examId:
//         selectedExamId
// });


//     const normalizedData = finalAssignedData.map(normalize);
//     const validExamId = Number.isFinite(Number(selectedExamId)) ? selectedExamId : 1;
//     // const basePayload = {
//     //     difficultyId,
//     //     scheduleDate,
//     //     expiryDate,
//     //     examId: validExamId,
//     //     duration: selectedExamDuration,
//     // };

//     const updatedAssignedData = normalizedData.map(item => ({
//         ...item,
//         employee_guid: item.id, // map id to employee_guid
//         id: undefined // optional: remove id
//     }));
//     const payloadNormal = {
//         examData: [
//             {
//                 examId: selectedExamId,
//                 duration: selectedExamDuration,
//             }
//         ],
//         // assignedData: updatedAssignedData,
//         assignedData: normalizedData,
//         scheduleDate,
//         expiryDate,
//         assignmentId: selectedAssignmentId,
//         workStart,
//         workEnd,
//     };

//     const requests = [];


//     const payloadOneTime = finalOneTimeAssignedData.map((emp) => ({
//         firstName: emp.firstName,
//         lastName: emp.lastName,
//         email: emp.email,
//         password: emp.password,
//         departmentId: emp.departmentId,
//         status: 1,
//         isActive: true,
//         assignmentId: 3,
//     }));
//     // try {
//     //     const requests = [];
//     //     if (normalizedData.length > 0) {
//     //         requests.push(
//     //             axios.post(`/coordinators/assign-exam/`, {
//     //                 ...basePayload,
//     //                 assignedData: normalizedData,
//     //             })
//     //         );
//     //     }
//     //     if (payloadOneTime.length > 0) {
//     //         requests.push(
//     //             axios.post(`/coordinators/assign-exam-onetime/`, {
//     //                 ...basePayload,
//     //                 oneTimeEmployee: payloadOneTime,
//     //             })
//     //         );
//     //     }
//     //     const responses = await Promise.all(requests);
//     //     responses.forEach((res, idx) => console.log(`✅ API response [${idx}]:`, res.data));
//     //     setSuccessOpen(true);
//     // } catch (err) {
//     //     setError(err.response?.data?.message || err.response?.data?.error || "Failed to submit the data");
//     // }
//     // if (!isEdit) {
//     //     console.log("Not Edit(normal)")
//     //     if (normalizedData.length > 0) {
//     //         requests.push(
//     //             axios.post(`/coordinators/assign-exam/`, payloadNormal)
//     //         );
//     //     }

//     //     if (payloadOneTime.length > 0) {
//     //         requests.push(
//     //             axios.post(`/coordinators/assign-exam-onetime/`, {
//     //                 ...payloadNormal,
//     //                 oneTimeEmployee: payloadOneTime,
//     //             })
//     //         );
//     //     }
//     // } 
//     if (!isEdit) {
//     console.log("Not Edit(normal)");
//     console.log("Auto Scheduling =", autoScheduling);

//     const assignApi =
//         autoScheduling === 1
//             ? `/coordinators/assign-exam/`
//             : `/coordinators/manual_assignement/`;

//     if (normalizedData.length > 0) {
//         requests.push(
//             axios.post(assignApi, payloadNormal)
//         );
//     }

//     if (payloadOneTime.length > 0) {
//         requests.push(
//             axios.post(`/coordinators/assign-exam-onetime/`, {
//                 ...payloadNormal,
//                 oneTimeEmployee: payloadOneTime,
//             })
//         );
//     }
// }
//     else {
//         console.log("it is edit ")

//         // --- PUT: Update only inactive exam employees ---
//         const inactiveEmployees = finalAssignedData.filter(
//             (emp) => emp.isActive === false && emp.examEmployeeId
//         );

//         if (inactiveEmployees.length > 0) {
//             const payloadPut = inactiveEmployees.map((emp) => ({
//                 examEmployeeId: emp.examEmployeeId,
//                 isActive: false,
//             }));

//             console.log("🟠 PUT Payload (Deactivate Employees):", payloadPut);

//             requests.push(
//                 axios.put(`/coordinators/assign-exam/`, {
//                     employees: payloadPut,
//                 })
//             );
//         }
//     }

//     try {
//         if (requests.length > 0) {
//             // Execute all requests and wait for all to finish
//             const responses = await Promise.all(requests);

//             // Optional: log responses
//             responses.forEach((res, idx) =>
//                 console.log(`✅ API response [${idx}]:`, res.data)
//             );
//         }

//         // ✅ Show success only if all requests succeeded
//         setSuccessOpen(true);
//         if (navigate) {
//             navigate('/hr/assignment-exams');
//         }
//     } catch (err) {
//         console.log("❌ Error during confirmSaveCourse:", err);
//         setError(
//             err.response?.data?.message ||
//             err.response?.data?.error ||
//             "Failed to submit the data"
//         );
//     }

// };

// const handleClear = (
//     setAssignmentType,
//     setSelectedDepartments,
//     setSelectedEmployees,
//     setDifficulty,
//     setExams,
//     setScheduleDate,
//     setExpiryDate,
//     setOneTimeUsers,
//     setDifficultyId,
//     setAssignedData,
//     setSelectedAssignmentId,
//     setOneTimeEmployees,
//     setSelectedExam,
//     setSelectedExamId,
// ) => {
//     if (setAssignmentType) setAssignmentType(null);
//     setSelectedDepartments([]);
//     setSelectedEmployees([]);
//     setDifficulty('');
//     setExams([]);
//     setScheduleDate(format(addHours(startOfDay(new Date()), 9), "yyyy-MM-dd'T'HH:mm"));
//     setExpiryDate(format(addHours(startOfDay(new Date()), 18), "yyyy-MM-dd'T'HH:mm"));
//     setOneTimeUsers([]);
//     setDifficultyId(null);
//     setAssignedData([]);
//     setSelectedAssignmentId(null);
//     setOneTimeEmployees([]);
//     setSelectedExam('');
//     setSelectedExamId(null);
// };

// export { handleAssignmentTypeChange, mergeAssignedData, handleAssign, resetform, confirmSaveCourse, handleClear };












import { ClassNames } from '@emotion/react';
import axios from 'axios';
import { format, startOfDay, addHours } from 'date-fns';

const handleAssignmentTypeChange = (event, assignments, setAssignmentType, setSelectedAssignmentId, selectedExamId, setError) => {
    setAssignmentType(event.target.value);

    let assignmentId = assignments.find(a => a.name === event.target.value)?.id || null;
    // Special case: "Groups" → force assignmentId = 4
    if (event.target.value === "Groups") {
        assignmentId = 4;
    }
    setSelectedAssignmentId(assignmentId);
    if (!selectedExamId) {
        setError("Please select an assessment before choosing an assignment type.");
    }
};

const mergeAssignedData = (data, assignmentId, setAssignedData) => {
    setAssignedData((prev) => {
        const filteredPrev = prev.filter(item => item.assignmentId !== assignmentId);
        const taggedNew = data.map(item => ({ ...item, assignmentId }));
        return [...filteredPrev, ...taggedNew];
    });
};

const handleAssign = (
    difficultyId, 
    scheduleDate, 
    expiryDate, 
    selectedExamId, 
    assignedData, 
    oneTimeEmployees, 
    selectedExamDuration, 
    setError, 
    setConfirmationType, 
    setConfirmOpen, 
    isEdit, 
    assignmentType,
    selectedEmployeesCount,
    selectedDepartmentsCount,
    workStart,
    workEnd,
    autoScheduling,
    navigate,
    // New parameters for dialog handlers
    setRescheduleDialogOpen,
    setRescheduleDialogData,
    setErrorDialogOpen,
    setErrorDialogData
) => {
    setError("");
    try {
        if (!isEdit) {
            // Basic required fields
            if (!scheduleDate) { setError("Schedule date is required"); return; }
            if (!expiryDate) { setError("Expiry date is required"); return; }
            if (!selectedExamId) { setError("Assessment is required"); return; }

            // Assignment type validation
            if (!assignmentType) {
                setError("Please select an assignment type (Individual or Department).");
                return;
            }

            // Individual type: check if at least one employee is selected
            if (assignmentType === "Individual") {
                const hasEmployees = selectedEmployeesCount > 0 || (oneTimeEmployees && oneTimeEmployees.length > 0);
                if (!hasEmployees) {
                    setError("At least one employee must be added.");
                    return;
                }
            }
            // Department type: check if at least one department is selected
            else if (assignmentType === "Department") {
                if (!selectedDepartmentsCount) {
                    setError("At least one department must be assigned.");
                    return;
                }
            }
            // Optional: handle Groups (assignmentId 4) – if needed
            else if (assignmentType === "Groups") {
                // Add your logic here if Groups require any validation
                // For now, we allow it but you can add a check
            }
            // Fallback for any other type
            else {
                setError("Invalid assignment type selected.");
                return;
            }
        }
        const scheduleDateTime = new Date(scheduleDate);
        const expiryDateTime = new Date(expiryDate);
        if (expiryDateTime <= scheduleDateTime) {
            setError("Expiry date and time must be after schedule date and time.");
            return;
        }
        setConfirmationType("save");
        setConfirmOpen(true);
    } catch (err) {
        setError("Unexpected error occurred while assigning assessment.");
    }
};

const resetform = (
    setAssignmentType,
    setSelectedDepartments,
    setSelectedEmployees,
    setDifficulty,
    setExams,
    setScheduleDate,
    setExpiryDate,
    setOneTimeUsers,
    setDifficultyId,
    setSelectedExam,
    setSelectedExamId,
    setAssignedData,
    setSelectedAssignmentId,
    setIndividuals,
    setDepartments,
    navigate
) => {
    if (setAssignmentType) setAssignmentType(null);
    setSelectedDepartments([]);
    setSelectedEmployees([]);
    setDifficulty('');
    setExams([]);
    setScheduleDate(format(addHours(startOfDay(new Date()), 9), "yyyy-MM-dd'T'HH:mm"));
    setExpiryDate(format(addHours(startOfDay(new Date()), 18), "yyyy-MM-dd'T'HH:mm"));
    setOneTimeUsers([]);
    setDifficultyId(null);
    setSelectedExam('');
    setSelectedExamId(null);
    setAssignedData([]);
    setSelectedAssignmentId(null);
    setIndividuals([]);
    setDepartments([]);
    navigate('/hr/assignment-exams');
};

// const confirmSaveCourse = async (
//     isEdit, 
//     assignedData, 
//     oneTimeEmployees, 
//     difficultyId, 
//     scheduleDate, 
//     expiryDate, 
//     selectedExamId, 
//     selectedExamDuration, 
//     setError, 
//     setConfirmOpen, 
//     setSuccessOpen, 
//     selectedAssignmentId, 
//     workStart, 
//     workEnd, 
//     autoScheduling, 
//     navigate,
//     // New parameters for dialog handlers
//     setRescheduleDialogOpen,
//     setRescheduleDialogData,
//     setErrorDialogOpen,
//     setErrorDialogData
// ) => {
//     setError("");
//     console.log("Confirm Save Course triggered");
//     setConfirmOpen(false);
    
//     const finalAssignedData = (Array.isArray(assignedData) ? assignedData : []).filter((item) => {
//         if (isEdit === false) return item.isActive === true;
//         if (isEdit === true) return true;
//         return item.isActive === true;
//     });

//     const finalOneTimeAssignedData = (Array.isArray(oneTimeEmployees) ? oneTimeEmployees : []).filter((item) => {
//         if (isEdit === false) return item.isActive === true;
//         if (isEdit === true) return true;
//         return item.isActive === true;
//     });

//     const normalize = (emp) => ({
//         employee_guid: emp.employee_guid ?? emp.id ?? emp.employeeId ?? null,
//         employeeId: emp.employeeId ?? emp.id ?? null,
//         employeeName: emp.employeeName?.trim() || "",
//         departmentId: emp.departmentId ?? null,
//         departmentName: emp.departmentName ?? "",
//         groupId: emp.groupId ?? null,
//         groupName: emp.groupName ?? "",
//         assignmentId: emp.assignmentId ?? selectedAssignmentId,
//         isActive: emp.isActive ?? true,
//         status: emp.status ?? "Scheduled",
//         examId: selectedExamId
//     });

//     const normalizedData = finalAssignedData.map(normalize);
//     const validExamId = Number.isFinite(Number(selectedExamId)) ? selectedExamId : 1;

//     const payloadNormal = {
//         examData: [
//             {
//                 examId: selectedExamId,
//                 duration: selectedExamDuration,
//             }
//         ],
//         assignedData: normalizedData,
//         scheduleDate,
//         expiryDate,
//         assignmentId: selectedAssignmentId,
//         workStart,
//         workEnd,
//     };

//     const payloadOneTime = finalOneTimeAssignedData.map((emp) => ({
//         firstName: emp.firstName,
//         lastName: emp.lastName,
//         email: emp.email,
//         password: emp.password,
//         departmentId: emp.departmentId,
//         status: 1,
//         isActive: true,
//         assignmentId: 3,
//     }));

//     const requests = [];

//     if (!isEdit) {
//         console.log("Not Edit(normal)");
//         console.log("Auto Scheduling =", autoScheduling);

//         const assignApi = autoScheduling === 1
//             ? `/coordinators/assign-exam/`
//             : `/coordinators/manual_assignement/`;

//         if (normalizedData.length > 0) {
//             requests.push(
//                 axios.post(assignApi, payloadNormal)
//             );
//         }

//         if (payloadOneTime.length > 0) {
//             requests.push(
//                 axios.post(`/coordinators/assign-exam-onetime/`, {
//                     ...payloadNormal,
//                     oneTimeEmployee: payloadOneTime,
//                 })
//             );
//         }
//     } else {
//         console.log("it is edit ")

//         // --- PUT: Update only inactive exam employees ---
//         const inactiveEmployees = finalAssignedData.filter(
//             (emp) => emp.isActive === false && emp.examEmployeeId
//         );

//         if (inactiveEmployees.length > 0) {
//             const payloadPut = inactiveEmployees.map((emp) => ({
//                 examEmployeeId: emp.examEmployeeId,
//                 isActive: false,
//             }));

//             console.log("🟠 PUT Payload (Deactivate Employees):", payloadPut);

//             requests.push(
//                 axios.put(`/coordinators/assign-exam/`, {
//                     employees: payloadPut,
//                 })
//             );
//         }
//     }

//     try {
//         if (requests.length > 0) {
//             const responses = await Promise.all(requests);
//             responses.forEach((res, idx) =>
//                 console.log(`✅ API response [${idx}]:`, res.data)
//             );
//         }

//         setSuccessOpen(true);
//         if (navigate) {
//             navigate('/hr/assignment-exams');
//         }
//     } catch (err) {
//         console.log("❌ Error during confirmSaveCourse:", err);
        
//         const errorData = err.response?.data;
//         const errorMsg = errorData?.message || errorData?.error || "Failed to submit the data";
//         const action = errorData?.action;
        
//         // Check for specific error types
//         if (action === "RESCHEDULE") {
//             // Open reschedule dialog with employee info
//             if (setRescheduleDialogData) {
//                 setRescheduleDialogData({
//                     message: errorMsg,
//                     employees: errorData?.employees || [],
//                     action: "RESCHEDULE"
//                 });
//             }
//             if (setRescheduleDialogOpen) {
//                 setRescheduleDialogOpen(true);
//             }
//             return;
//         } else if (action === "MAX_ATTEMPTS_REACHED") {
//             // Open max attempts dialog
//             if (setErrorDialogData) {
//                 setErrorDialogData({
//                     message: errorMsg,
//                     type: "MAX_ATTEMPTS_REACHED",
//                     examId: selectedExamId
//                 });
//             }
//             if (setErrorDialogOpen) {
//                 setErrorDialogOpen(true);
//             }
//             return;
//         } else {
//             // Regular error
//             setError(errorMsg);
//         }
//     }
// };



const confirmSaveCourse = async (
    isEdit, 
    assignedData, 
    oneTimeEmployees, 
    difficultyId, 
    scheduleDate, 
    expiryDate, 
    selectedExamId, 
    selectedExamDuration, 
    setError, 
    setConfirmOpen, 
    setSuccessOpen, 
    selectedAssignmentId, 
    workStart, 
    workEnd, 
    autoScheduling, 
    navigate,
    // Optional dialog handlers - only used when there's an error
    setRescheduleDialogOpen,
    setRescheduleDialogData,
    setErrorDialogOpen,
    setErrorDialogData
) => {
    try {
        setError("");
        console.log("Confirm Save Course triggered");
        
        // Don't close confirm dialog here - let ConfirmDialog handle it
        // setConfirmOpen(false); // Remove this line
        
        const finalAssignedData = (Array.isArray(assignedData) ? assignedData : []).filter((item) => {
            if (isEdit === false) return item.isActive === true;
            if (isEdit === true) return true;
            return item.isActive === true;
        });

        const finalOneTimeAssignedData = (Array.isArray(oneTimeEmployees) ? oneTimeEmployees : []).filter((item) => {
            if (isEdit === false) return item.isActive === true;
            if (isEdit === true) return true;
            return item.isActive === true;
        });

        const normalize = (emp) => ({
            employee_guid: emp.employee_guid ?? emp.id ?? emp.employeeId ?? null,
            employeeId: emp.employeeId ?? emp.id ?? null,
            employeeName: emp.employeeName?.trim() || "",
            departmentId: emp.departmentId ?? null,
            departmentName: emp.departmentName ?? "",
            groupId: emp.groupId ?? null,
            groupName: emp.groupName ?? "",
            assignmentId: emp.assignmentId ?? selectedAssignmentId,
            isActive: emp.isActive ?? true,
            status: emp.status ?? "Scheduled",
            examId: selectedExamId
        });

        const normalizedData = finalAssignedData.map(normalize);
        const validExamId = Number.isFinite(Number(selectedExamId)) ? selectedExamId : 1;

        const payloadNormal = {
            examData: [
                {
                    examId: selectedExamId,
                    duration: selectedExamDuration,
                }
            ],
            assignedData: normalizedData,
            scheduleDate,
            expiryDate,
            assignmentId: selectedAssignmentId,
            workStart,
            workEnd,
        };

        const payloadOneTime = finalOneTimeAssignedData.map((emp) => ({
            firstName: emp.firstName,
            lastName: emp.lastName,
            email: emp.email,
            password: emp.password,
            departmentId: emp.departmentId,
            status: 1,
            isActive: true,
            assignmentId: 3,
        }));

        const requests = [];

        if (!isEdit) {
            console.log("Not Edit(normal)");
            console.log("Auto Scheduling =", autoScheduling);

            const assignApi = autoScheduling === 1
                ? `/coordinators/assign-exam/`
                : `/coordinators/manual_assignement/`;

            if (normalizedData.length > 0) {
                requests.push(
                    axios.post(assignApi, payloadNormal)
                );
            }

            if (payloadOneTime.length > 0) {
                requests.push(
                    axios.post(`/coordinators/assign-exam-onetime/`, {
                        ...payloadNormal,
                        oneTimeEmployee: payloadOneTime,
                    })
                );
            }
        } else {
            console.log("it is edit ")

            const inactiveEmployees = finalAssignedData.filter(
                (emp) => emp.isActive === false && emp.examEmployeeId
            );

            if (inactiveEmployees.length > 0) {
                const payloadPut = inactiveEmployees.map((emp) => ({
                    examEmployeeId: emp.examEmployeeId,
                    isActive: false,
                }));

                console.log("🟠 PUT Payload (Deactivate Employees):", payloadPut);

                requests.push(
                    axios.put(`/coordinators/assign-exam/`, {
                        employees: payloadPut,
                    })
                );
            }
        }

        if (requests.length > 0) {
            const responses = await Promise.all(requests);
            responses.forEach((res, idx) =>
                console.log(`✅ API response [${idx}]:`, res.data)
            );
        }

        // ✅ Show success only if all requests succeeded
        setSuccessOpen(true);
        
        // Navigate after a small delay to show the success dialog
        setTimeout(() => {
            if (navigate) {
                navigate('/hr/assignment-exams');
            }
        }, 2000);

    } catch (err) {
        console.log("❌ Error during confirmSaveCourse:", err);
        
        const errorData = err.response?.data;
        const errorMsg = errorData?.message || errorData?.error || "Failed to submit the data";
        const action = errorData?.action;
        
        // Check for specific error types - only if handlers are provided
        if (action === "RESCHEDULE" && setRescheduleDialogOpen && setRescheduleDialogData) {
            // Open reschedule dialog with employee info
            setRescheduleDialogData({
                message: errorMsg,
                employees: errorData?.employees || [],
                action: "RESCHEDULE"
            });
            setRescheduleDialogOpen(true);
            return;
        } else if (action === "MAX_ATTEMPTS_REACHED" && setErrorDialogOpen && setErrorDialogData) {
            // Open max attempts dialog
            setErrorDialogData({
                message: errorMsg,
                type: "MAX_ATTEMPTS_REACHED",
                examId: selectedExamId
            });
            setErrorDialogOpen(true);
            return;
        } else {
            // Regular error - show error message
            setError(errorMsg);
            // Reopen confirm dialog so user can try again
            setConfirmOpen(true);
        }
    }
};

const handleClear = (
    setAssignmentType,
    setSelectedDepartments,
    setSelectedEmployees,
    setDifficulty,
    setExams,
    setScheduleDate,
    setExpiryDate,
    setOneTimeUsers,
    setDifficultyId,
    setAssignedData,
    setSelectedAssignmentId,
    setOneTimeEmployees,
    setSelectedExam,
    setSelectedExamId,
) => {
    if (setAssignmentType) setAssignmentType(null);
    setSelectedDepartments([]);
    setSelectedEmployees([]);
    setDifficulty('');
    setExams([]);
    setScheduleDate(format(addHours(startOfDay(new Date()), 9), "yyyy-MM-dd'T'HH:mm"));
    setExpiryDate(format(addHours(startOfDay(new Date()), 18), "yyyy-MM-dd'T'HH:mm"));
    setOneTimeUsers([]);
    setDifficultyId(null);
    setAssignedData([]);
    setSelectedAssignmentId(null);
    setOneTimeEmployees([]);
    setSelectedExam('');
    setSelectedExamId(null);
};

export { 
    handleAssignmentTypeChange, 
    mergeAssignedData, 
    handleAssign, 
    resetform, 
    confirmSaveCourse, 
    handleClear 
};
